import { render, staticRenderFns } from "./scans.vue?vue&type=template&id=5d8188c4&scoped=true"
import script from "./scans.vue?vue&type=script&lang=js"
export * from "./scans.vue?vue&type=script&lang=js"
import style0 from "./scans.vue?vue&type=style&index=0&id=5d8188c4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d8188c4",
  null
  
)

export default component.exports